<template>
  <v-simple-table dense style="border: 1px solid #d1d1d1">
    <template v-slot:default>
      <thead>
        <tr>
          <th class="text-left caption">#</th>
          <th class="text-left caption">NOMBRE</th>
          <th class="text-right caption">ENERO</th>
          <th class="text-right caption">FEBRERO</th>
          <th class="text-right caption">MARZO</th>
          <th class="text-right caption">ABRIL</th>
          <th class="text-right caption">MAYO</th>
          <th class="text-right caption">JUNIO</th>
          <th class="text-right caption">JULIO</th>
          <th class="text-right caption">AGOSTO</th>
          <th class="text-right caption">SEPTIEMBRE</th>
          <th class="text-right caption">OCTUBRE</th>
          <th class="text-right caption">NOVIEMBRE</th>
          <th class="text-right caption">DICIEMBRE</th>
          <th class="text-right caption">TOTAL</th>
        </tr>
      </thead>

      <tbody>
        <tr v-if="estimaciones.length == 0">
          <td colspan="15" class="text-center caption">No hay datos registrados</td>
        </tr>
        <template v-if="mostradoDetalle">
          <tr v-for="(estimacion, indice) in estimaciones" :key="estimacion.estimacion_id">
            <td class="text-left caption">{{ indice + 1 }}</td>
            <td class="text-left caption">{{ estimacion.nombre }}</td>
            <td class="text-right caption">{{ formatearNumero(estimacion.enero) }}</td>
            <td class="text-right caption">{{ formatearNumero(estimacion.febrero) }}</td>
            <td class="text-right caption">{{ formatearNumero(estimacion.marzo) }}</td>
            <td class="text-right caption">{{ formatearNumero(estimacion.abril) }}</td>
            <td class="text-right caption">{{ formatearNumero(estimacion.mayo) }}</td>
            <td class="text-right caption">{{ formatearNumero(estimacion.junio) }}</td>
            <td class="text-right caption">{{ formatearNumero(estimacion.julio) }}</td>
            <td class="text-right caption">{{ formatearNumero(estimacion.agosto) }}</td>
            <td class="text-right caption">{{ formatearNumero(estimacion.septiembre) }}</td>
            <td class="text-right caption">{{ formatearNumero(estimacion.octubre) }}</td>
            <td class="text-right caption">{{ formatearNumero(estimacion.noviembre) }}</td>
            <td class="text-right caption">{{ formatearNumero(estimacion.diciembre) }}</td>
            <td class="text-right caption">{{ formatearNumero(estimacion.total) }}</td>
          </tr>
        </template>
        <tr>
          <td></td>
          <td class="text-left caption">TOTALES</td>
          <td class="text-right caption">
            {{ formatearNumero(estimaciones.reduce((a, b) => a + parseFloat(b.enero), 0)) }}
          </td>
          <td class="text-right caption">
            {{ formatearNumero(estimaciones.reduce((a, b) => a + parseFloat(b.febrero), 0)) }}
          </td>
          <td class="text-right caption">
            {{ formatearNumero(estimaciones.reduce((a, b) => a + parseFloat(b.marzo), 0)) }}
          </td>
          <td class="text-right caption">
            {{ formatearNumero(estimaciones.reduce((a, b) => a + parseFloat(b.abril), 0)) }}
          </td>
          <td class="text-right caption">
            {{ formatearNumero(estimaciones.reduce((a, b) => a + parseFloat(b.mayo), 0)) }}
          </td>
          <td class="text-right caption">
            {{ formatearNumero(estimaciones.reduce((a, b) => a + parseFloat(b.junio), 0)) }}
          </td>
          <td class="text-right caption">
            {{ formatearNumero(estimaciones.reduce((a, b) => a + parseFloat(b.julio), 0)) }}
          </td>
          <td class="text-right caption">
            {{ formatearNumero(estimaciones.reduce((a, b) => a + parseFloat(b.agosto), 0)) }}
          </td>
          <td class="text-right caption">
            {{ formatearNumero(estimaciones.reduce((a, b) => a + parseFloat(b.septiembre), 0)) }}
          </td>
          <td class="text-right caption">
            {{ formatearNumero(estimaciones.reduce((a, b) => a + parseFloat(b.octubre), 0)) }}
          </td>
          <td class="text-right caption">
            {{ formatearNumero(estimaciones.reduce((a, b) => a + parseFloat(b.noviembre), 0)) }}
          </td>
          <td class="text-right caption">
            {{ formatearNumero(estimaciones.reduce((a, b) => a + parseFloat(b.diciembre), 0)) }}
          </td>
          <td class="text-right caption">
            {{ formatearNumero(estimaciones.reduce((a, b) => a + parseFloat(b.total), 0)) }}
          </td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
import { formatearNumero } from './../../utils.js';

export default {
  name: 'ReporteIngresosTabla',
  props: {
    estimaciones: {
      type: Array,
      default: () => [],
    },
    mostradoDetalle: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    formatearNumero,
  },
};
</script>

<style>
</style>